import * as React from 'react';
import EditorPage from '../pages/EditorPage';
import ImportExportPage from '../pages/ImportExportPage';
import PartsPage from '../pages/PartsPage';
import StartPage from '../pages/StartPage';
import TemplatesPage from '../pages/TemplatesPage';
import { Store } from '../types';

interface ViewProps {
    page: Store['session']['page'];
}

export default function View({ page }: ViewProps) {
    function pageSwitch() {
        switch (page) {
            default:
            case 'start':
                return <StartPage />;
            case 'kite':
                return <EditorPage />;
            case 'parts':
                return <PartsPage />;
            case 'templates':
                return <TemplatesPage />;
            case 'importExport':
                return <ImportExportPage />;
        }
    }

    return <div className="view">{pageSwitch()}</div>;
}
